import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { NeutralTag } from '@grnhse/seedling/lib/birch/components/tags';
import { Person } from 'talent_matching/types';

interface TagsCellProps {
  person: Person;
}

const TagsCell = ({ person }: TagsCellProps) => {
  if (!person?.tags) {
    return null;
  }

  return (
    <div
      className="pii-blur"
      style={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}
    >
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        alignContent="flex-start"
        sx={{
          padding: 1,
          paddingLeft: 0,
        }}
      >
        {person.tags.map((tag: { label: string; value: string }) => (
          <NeutralTag key={tag.value} text={tag.label} />
        ))}
      </Stack>
    </div>
  );
};

export default TagsCell;
